<template>
  <div id="app">
    <router-view />
    <SessionExpiredOverlay />
    <UpdateBanner v-if="updateAvailable" />
  </div>
</template>

<script setup lang="ts">
import { useSessionRefresh } from '@/composables/useSessionRefresh'
import { useVersionCheck } from '@/composables/useVersionCheck'
import { useChunkErrorHandler } from '@/composables/useChunkErrorHandler'
import SessionExpiredOverlay from '@/components/organisms/SessionExpiredOverlay.vue'
import UpdateBanner from '@/components/molecules/UpdateBanner.vue'

useChunkErrorHandler()
const { startListening } = useSessionRefresh()
startListening()
const { updateAvailable, startPolling } = useVersionCheck()
startPolling()
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  background-color: var(--cds-background);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
